import {Filter, TextInput, useLocale, useTranslate} from "react-admin"
import * as React from "react";
import DateFnsUtils from "@date-io/date-fns";
import {enUS, pt} from "date-fns/locale";

import {DateTimeInput} from "../datetime";

export const RestaurantProductFilter = (props) => {
    const locale = useLocale();
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <TextInput label="pos.search" source="q" alwaysOn/>
            <TextInput source="price_gte"/>
            <TextInput source="price_lte"/>
            <TextInput source="tax_gte"/>
            <TextInput source="tax_lte"/>
            <DateTimeInput
                label={translate('resources.restaurant-products.fields.created_at_gte')}
                source="created_at_gte"
                options={{
                    format: 'dd/MM/yyyy, HH:mm:ss',
                    ampm: false,
                    clearable: true,
                    clearLabel: translate('dialog.actions.clearLabel'),
                    cancelLabel: translate('dialog.actions.cancelLabel'),
                    okLabel: translate('dialog.actions.okLabel')
                }}
                providerOptions={{utils: DateFnsUtils, locale: locale === 'pt' ? pt : enUS}}
            />
            <DateTimeInput
                label={translate('resources.restaurant-products.fields.created_at_lte')}
                source="created_at_lte"
                options={{
                    format: 'dd/MM/yyyy, HH:mm:ss',
                    ampm: false,
                    clearable: true,
                    clearLabel: translate('dialog.actions.clearLabel'),
                    cancelLabel: translate('dialog.actions.cancelLabel'),
                    okLabel: translate('dialog.actions.okLabel')
                }}
                providerOptions={{utils: DateFnsUtils, locale: locale === 'pt' ? pt : enUS}}
            />
        </Filter>
    );
}
